<template>
  <v-main>
    <v-container class="mt-10" fluid>
      <v-row align="center" justify="center">
        <v-card flat max-width="100%">
          <v-card-title class="justify-center">
            <h2>ページが見つかりません</h2>
          </v-card-title>
          <v-card-text>
            <div class="text-center">リクエストされたページが見つかりませんでした。</div>
            <div class="text-center">
              <router-link id="toLogin" :to="{ name: 'Login' }">ログイン画面へ戻る</router-link>
            </div>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  created: function () {
    this.$cookies.remove('access_token');
  },
};
</script>
